import {useTranslation} from 'react-i18next';
import React from 'react';
import {Button} from 'primereact/button';
import "antd/dist/antd.css";

const _ = require("lodash");

export function FTUTrans(props) {
    const {t} = useTranslation(props.ns);

    if (props.vari) {
        return t(props.name, props.vari);
    } else {
        return t(props.name);
    }
}

export class FTUConfirmMessage extends React.Component {
    render() {
        return (
            <div>
                <span>{this.props.message}</span>
                <br></br>
                <div>
                    <center>
                        <Button label={this.props.labelAccept} onClick={this.props.acceptOnClick}/>
                        &nbsp;
                        <Button label={this.props.labelCancel} onClick={this.props.cancelOnClick}/>
                    </center>
                </div>

            </div>
        );
    }
}

export class FTUComponent extends React.Component {
    trans(name, vari) {
        let value;
        if (vari) {
            value = this.props.t(name, vari);
        } else {
            value = this.props.t(name);
        }

        return value;
    }

    txtHandleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    focusFirstElement = (id) => {
        const element = document.getElementById(id);
        if (!element) {
            return false;
        }
        this.focusEl(element);
    };

    focusInvalidInput = (errors) => {
        const id = Object.keys(errors)[0];
        const element = document.getElementById(id);
        if (element) {
            if (element.tabIndex === -1) {
                this.focusEl(element);
            } else {
                element.focus();
            }
        }
    };

    focusEl = (element) => {
        const _ = require('lodash');
        let listFocus = element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        listFocus = _.filter(listFocus, el => !el.disabled && !el.hidden && el.tabIndex !== -1);
        if (listFocus && listFocus.length) {
            listFocus[0].focus();
        }
    };

    formatInput = (str, filter) => {
        if (filter === "number") {
            const _ = require('lodash');
            str = str.toString().trim();
            str = str.replace(/[^0-9]/g, ''); //Loại bỏ ký tự không phải số.
            return _.toInteger(str);
        }
        if (filter.includes("alpha")) {
            // Xóa space
            str = str.replace(/\s+/g, '');
            //Bỏ dấu tiếng Việt.
            str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
            str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
            str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
            str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
            str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
            str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
            str = str.replace(/đ/g, "d");
            str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
            str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
            str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
            str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
            str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
            str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
            str = str.replace(/Đ/g, "D");
            // Combining Diacritical Marks
            str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // huyền, sắc, hỏi, ngã, nặng
            str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // mũ â (ê), mũ ă, mũ ơ (ư)
            if (filter === "alpha_number")
            //Bỏ ký tự không phải chữ cái và số.
                str = str.replace(/[^0-9a-z_]/gi, '');
            else if (filter === "alpha")
            //Bỏ ký tự không phải chữ cái.
                str = str.replace(/[^a-z]/gi, '');
        }
        return str;
    }

    onChangeTxtField = (name, e) => {
        const filter = e.target.getAttribute("filter");
        if (filter)
            e.target.value = this.formatInput(e.target.value, filter);
        this.onChangeValue(this, name, e.target);
    };

    onChangeChkField = (name, e) => {
        this.onChangeValue(this, name, e.checked ? 1 : 0);
    };

    onChangeNumberField = (name, e) => {
        e.target.value = this.formatInput(e.target.value, "number");
        this.onChangeValue(this, name, e.target);
    };


    onChangeNumber = (name, event) => {
        this.onChangeValue(this, name, event);
    }
    onChangeSelect = name => value => {
        this.onChangeValue(this, name, value);
    };

    onChangeSelectDetailCustom = (context, value, option, stateProp) => {
        if (option && option.props.ftuitem) {
            context.setState(prevState => ({
                data: {
                    ...prevState.data,
                    [stateProp]: option.props.ftuitem
                },
                errors: {
                    ...prevState.errors,
                    [stateProp]: null
                }
            }));
        }
    }

    onChangeSelectDetail = (name, detail, optionRender, data, value) => {
        this.onChangeValue(this, name, value);
        let detailValue = value;
        if (data) {
            data.forEach(item => {
                if (item[optionRender.code] === value) {
                    detailValue = item[optionRender.name];
                    return;
                }
            });
        }
        this.onChangeValue(this, detail, detailValue);
    }

    onChangeCheckBox = name => value => {
        if (value.target.checked) {
            this.onChangeValue(this, name, "1");
        } else {
            this.onChangeValue(this, name, "0");
        }
    };

    async onChangeValue(context, name, value) {
        let realValue = "";
        /*if (value === undefined || value === null || value === "") {
            return;
        }*/
        if (value === undefined || value === null || typeof value.value === "undefined") {
            if (value === 'null') {
                realValue = "";
            } else {
                realValue = value;
            }
        } else {
            realValue = value.value;
        }

        await context.setState(prevState => ({
            data: {
                ...prevState.data,
                [name]: realValue
            },
            errors: {
                ...prevState.errors,
                [name]: ""
            }
        }));
        if (context.props.options) {
            if (context.props.options.dataNew) {
                context.props.options.dataNew = context.state.data;
            }
        }
    }

    onChangeNestedObject = (name, child) => value => {
        if (value === 'null') {
            value = "";
        }
        value = {[child]: value};
        this.onChangeValue(this, name, value)
    }

    onChangeDate = async (name, value) => {
        if (value === undefined || value === "") {
            value = null;
        }
        await this.setState(prevState => ({
            data: {
                ...prevState.data,
                [name]: value
            },
            errors: {
                ...prevState.errors,
                [name]: ""
            }
        }));
        if (this.props.options) {
            if (this.props.options.dataNew) {
                this.props.options.dataNew = this.state.data;
            }
        }
    }

    onChangeDateString = async (name, value, valueString) => {
        if (valueString === undefined || valueString === "") {
            valueString = null;
        }
        await this.setState(prevState => ({
            data: {
                ...prevState.data,
                [name]: valueString
            },
            errors: {
                ...prevState.errors,
                [name]: ""
            }
        }));
        if (this.props.options) {
            if (this.props.options.dataNew) {
                this.props.options.dataNew = this.state.data;
            }
        }
    }

    getSelectedData = (dt, data, key) => {
        let dataSelected = {};
        if (dt && dt.state && dt.processData() && dt.processData().length) {
            const listData = dt.processData();
            if (data) { // TH thêm bản ghi
                const index = _.findIndex(listData, {[key]: data[key]});
                if (index !== -1) {
                    dataSelected = listData[index];
                    dt.state.first = index - index % dt.state.rows; //set lại trang của table
                } else {
                    dataSelected = listData[0];
                    dt.state.first = 0; //set lại trang của table (nhảy về trang đầu)
                }
            } else { // TH xóa + mặc định khi mở form
                dataSelected = listData[0];
                dt.state.first = 0; //set lại trang của table (nhảy về trang đầu)
            }
        } else if (dt && dt.state) {
            dt.state.first = 0;
        }
        return dataSelected;
    };

    _resolveWaitRedux(func) {
        setTimeout(() => {
            if (this.props.user && this.props.user.username && this.props.user.shopName) {
                func();
            } else {
                this._resolveWaitRedux(func);
            }
        }, 200);
    }

    waitRedux() {
        return new Promise(resolve => {
            this._resolveWaitRedux(resolve);
        });
    }
}